import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules"; // ✅ include Autoplay
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "swiper/css";
import "swiper/css/navigation";

const testimonials = [
  {
    id: 1,
    image: "https://mhcockpit.com/Media/Landing/CPL/Safaa.jpg",
    text: "Training at MH Cockpit gave me the skills and confidence to handle real-world flying conditions. The perfect mix of practical flying and theory, along with supportive instructors, made learning safe, professional, and enjoyable. I’d recommend MH Cockpit to anyone dreaming of becoming a pilot.",
    name: "Safaa",
    role: "Student Pilot",
  },
  {
    id: 2,
    image: "https://mhcockpit.com/Media/Landing/CPL/Vignesh.jpg",
    text: "MH Cockpit’s training program built a strong foundation for my aviation career. The instructors guided me with patience and clarity, ensuring every concept was crystal clear. It was an inspiring journey that gave me the confidence to pursue my pilot dreams.",
    name: "Vignesh",
    role: "Student Pilot",
  },
  {
    id: 3,
    image: "https://mhcockpit.com/Media/Landing/CPL/Ayushi.jpg",
    text: "From the very first day, MH Cockpit made me feel like I was on the right path. The structured training, modern aircraft, and experienced mentors helped me grow as both a learner and a future pilot. I truly value the hands-on exposure I gained here.",
    name: "Ayushi",
    role: "Student Pilot",
  },
  {
    id: 4,
    image: "https://mhcockpit.com/Media/Landing/CPL/Sriram.jpg",
    text: "Learning at MH Cockpit was an unforgettable experience. The balance of discipline and encouragement from my instructors kept me motivated throughout my journey. I am grateful for the professional environment that prepared me for real aviation challenges.",
    name: "Sriram",
    role: "Student Pilot",
  },
  {
    id: 5,
    image: "https://mhcockpit.com/Media/Landing/CPL/Lekha.jpg",
    text: "MH Cockpit is more than just a training institute—it’s a place that shapes character and skill. With their excellent facilities and passionate instructors, I not only learned to fly but also developed the confidence to chase my aviation goals with determination.",
    name: "Lekha",
    role: "Student Pilot",
  },
];


const TestimonialCarousel = () => {
  return (
    <div
      className="relative bg-cover bg-center py-16 px-4"
      style={{
        backgroundImage: `url('https://mhcockpit.com/Media/Landing/CPL/Testi-bg.jpg')`, // replace with your background
      }}
    >
      <div className="max-w-5xl mx-auto relative bg-white rounded-lg shadow-lg p-20 max-sm:p-10 overflow-hidden">
        <h2 className="text-center text-lg font-semibold tracking-wider mb-6">
          STUDENT PILOT TESTIMONIALS
        </h2>

        {/* Swiper Carousel */}
        <Swiper
          modules={[Navigation, Autoplay]} // ✅ include autoplay
          navigation={{
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          }}
          loop={true}
          slidesPerView={1}
          autoplay={{
            delay: 4000, // ⏱ 4 seconds delay
            disableOnInteraction: false, // keep autoplay after user interaction
          }}
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="flex flex-col md:flex-row items-center gap-20 max-sm:gap-10">
                {/* Left Image */}
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-48 h-48 object-cover rounded-md"
                />

                {/* Right Content */}
                <div className="text-center">
                  <p className="text-gray-700 leading-relaxed">{item.text}</p>
                  <p className="mt-4 font-semibold">
                    {item.name},{" "}
                    <span className="text-gray-500">{item.role}</span>
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Buttons */}
        <button className="swiper-button-prev-custom absolute left-5 top-1/2 -translate-y-1/2 bg-gray-100 hover:bg-gray-200 text-gray-700 p-2 rounded-full shadow-md z-10">
          <FaArrowLeft />
        </button>
        <button className="swiper-button-next-custom absolute right-5 top-1/2 -translate-y-1/2 bg-gray-100 hover:bg-gray-200 text-gray-700 p-2 rounded-full shadow-md z-10">
          <FaArrowRight />
        </button>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
